"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var ReactDOM = require("react-dom");
var Localize_1 = require("../../gen-src/Localize");
var Icons_1 = require("../icons/Icons");
var SharedWidgets_1 = require("../SharedWidgets");
var TabStyles_1 = require("../styles/TabStyles");
var Date_1 = require("../utils/Date");
var DomUtil_1 = require("../utils/DomUtil");
var Overlay_1 = require("../utils/Overlay");
var SharedWidgets_2 = require("../SharedWidgets");
var DatePickerWidget_1 = require("./DatePicker/DatePickerWidget");
var DomWidgets_1 = require("./DomWidgets");
var DateFormat;
(function (DateFormat) {
    DateFormat[DateFormat["ShortDateTime"] = 0] = "ShortDateTime";
    DateFormat[DateFormat["MediumDateTime"] = 1] = "MediumDateTime";
    DateFormat[DateFormat["LongDateTime"] = 2] = "LongDateTime";
    DateFormat[DateFormat["FullDateTime"] = 3] = "FullDateTime";
    DateFormat[DateFormat["ShortDate"] = 4] = "ShortDate";
    DateFormat[DateFormat["MediumDate"] = 5] = "MediumDate";
    DateFormat[DateFormat["LongDate"] = 6] = "LongDate";
    DateFormat[DateFormat["FullDate"] = 7] = "FullDate";
    DateFormat[DateFormat["ShortDateWithFullYear"] = 8] = "ShortDateWithFullYear";
    DateFormat[DateFormat["ShortDateTimeWithFullYear"] = 9] = "ShortDateTimeWithFullYear";
    DateFormat[DateFormat["ShortDateTimeWithFullYear24Hour"] = 10] = "ShortDateTimeWithFullYear24Hour";
    DateFormat[DateFormat["ShortDateMediumTimeWithFullYear"] = 11] = "ShortDateMediumTimeWithFullYear";
    DateFormat[DateFormat["ShortDateMediumTimeWithFullYear24Hour"] = 12] = "ShortDateMediumTimeWithFullYear24Hour";
})(DateFormat = exports.DateFormat || (exports.DateFormat = {}));
var DateInputFieldType;
(function (DateInputFieldType) {
    DateInputFieldType[DateInputFieldType["Line"] = 0] = "Line";
    DateInputFieldType[DateInputFieldType["Outline"] = 1] = "Outline";
})(DateInputFieldType = exports.DateInputFieldType || (exports.DateInputFieldType = {}));
var Shadow = TabStyles_1.TabStyles.Shadow, Colors = TabStyles_1.TabStyles.Colors, Sizing = TabStyles_1.TabStyles.Sizing;
var DateInputField = /** @class */ (function (_super) {
    tslib_1.__extends(DateInputField, _super);
    function DateInputField(props) {
        var _this = _super.call(this, props) || this;
        _this.datePickerId = DomUtil_1.generateId();
        _this.handleInputRef = function (ref) {
            _this.inputElement = ref;
        };
        _this.handleDropdownButtonRef = function (ref) {
            _this.dropdownButtonElement = ReactDOM.findDOMNode(ref);
        };
        _this.handleOverlayRef = function (ref) {
            _this.overlayElement = ref;
        };
        _this.handleButtonClick = function (e) {
            _this.toggleDatePicker();
        };
        _this.handleChange = function (inputText) {
            _this.setState({ inputText: inputText });
            var parsedDate = Date_1.getParsedDate(inputText, _this.props.terminus);
            if (parsedDate) {
                _this.triggerOnChange(parsedDate);
            }
            else {
                _this.close();
            }
        };
        _this.handleInputKeyDown = function (e) {
            if (!_this.props.hasDatePicker) {
                return;
            }
            switch (e.key) {
                case ' ':
                    if (_this.inputElement.selectionStart === 0 && _this.inputElement.selectionEnd === _this.inputElement.value.length) {
                        _this.open();
                        break;
                    }
                    return;
                case 'ArrowDown':
                    _this.open();
                    break;
                case 'ArrowUp':
                    _this.close();
                    break;
                default:
                    return;
            }
            e.preventDefault();
            e.stopPropagation();
        };
        _this.handleInputEnter = function () {
            var parsedDate = Date_1.getParsedDate(_this.state.inputText, _this.props.terminus);
            if (parsedDate) {
                _this.confirmDate(parsedDate, false);
            }
        };
        _this.handleOverlayKeyUp = function (e) {
            if (e.key === 'Escape') {
                _this.handleEscape();
                e.preventDefault();
            }
            e.stopPropagation();
        };
        _this.handleBlur = function (e) {
            var focusedElement = DomUtil_1.findBlurRelatedTarget(e);
            if (!_this.props.hasDatePicker || ((!_this.overlayElement || !_this.overlayElement.contains(focusedElement)) &&
                !_this.inputElement.contains(focusedElement) &&
                !_this.dropdownButtonElement.contains(focusedElement))) {
                var parsedDate = Date_1.getParsedDate(_this.state.inputText, _this.props.terminus);
                if (parsedDate && !_this.props.errorText) {
                    _this.confirmDate(parsedDate, false);
                }
                else {
                    _this.confirmDate(_this.props.selectedDate, true);
                }
            }
        };
        _this.handlePickerBlur = function (e) {
            var relatedTarget = DomUtil_1.findBlurRelatedTarget(e);
            if (e.currentTarget === e.target || !e.currentTarget.contains(relatedTarget)) {
                _this.handleBlur(e);
            }
        };
        _this.handleEscape = function () {
            _this.confirmDate(_this.props.selectedDate, true);
        };
        _this.handlePickerChange = function (date) {
            var dateWithTerminus = Date_1.getDateWithTerminus(date, Localize_1.Parsers.parseShortDate, _this.props.terminus);
            var input = _this.getFormattedDate(dateWithTerminus);
            _this.handleChange(input);
        };
        _this.handlePickerConfirm = function (date) {
            _this.confirmDate(date, true);
        };
        _this.renderDatePicker = function () {
            var datePickerProps = {
                autofocus: true,
                isDateDisabled: _this.props.isDatePickerDateDisabled,
                onChange: _this.handlePickerChange,
                onConfirm: _this.handlePickerConfirm,
                selectedDate: _this.props.selectedDate,
                showWeekNumbers: _this.props.showDatePickerWeekNumbers,
                testId: _this.props.testId + "-date-picker",
            };
            return React.createElement(DatePickerWidget_1.DatePickerWidget, tslib_1.__assign({}, datePickerProps));
        };
        var selectedDate = props.selectedDate;
        var initialInputText = Date_1.getDateFormatter(_this.props.displayFormat)(selectedDate);
        _this.state = {
            inputText: initialInputText,
        };
        return _this;
    }
    DateInputField.prototype.componentDidUpdate = function (prevProps, prevState) {
        if (prevState.isDatePickerOpen && !this.state.isDatePickerOpen) {
            this.onClosed();
        }
        else if (prevProps.displayFormat !== this.props.displayFormat) {
            this.setState({
                inputText: Date_1.getDateFormatter(this.props.displayFormat)(this.props.selectedDate)
            });
        }
        else if (!prevProps.errorText && this.props.errorText) {
            this.close();
        }
    };
    DateInputField.prototype.onClosed = function () {
        if (this.inputElement && window.document.body.contains(this.inputElement)) {
            this.inputElement.focus();
        }
    };
    DateInputField.prototype.open = function () {
        this.toggleDatePicker(true);
    };
    DateInputField.prototype.close = function () {
        this.toggleDatePicker(false);
    };
    DateInputField.prototype.toggleDatePicker = function (open) {
        if (open === void 0) { open = !this.state.isDatePickerOpen; }
        if (!this.props.hasDatePicker || open === this.state.isDatePickerOpen) {
            return;
        }
        this.setState({ isDatePickerOpen: open });
    };
    DateInputField.prototype.confirmDate = function (date, reformatInput) {
        if (reformatInput) {
            this.setState({ inputText: this.getFormattedDate(date) });
        }
        this.triggerOnConfirm(date);
        this.close();
    };
    DateInputField.prototype.triggerOnConfirm = function (date) {
        if (this.props.onConfirm) {
            this.props.onConfirm(date);
        }
    };
    DateInputField.prototype.triggerOnChange = function (date) {
        if (this.props.onChange) {
            this.props.onChange(date);
        }
    };
    DateInputField.prototype.getFormattedDate = function (date) {
        return Date_1.getDateFormatter(this.props.displayFormat)(date);
    };
    DateInputField.prototype.isOutlineTextField = function () {
        return this.props.dateInputFieldType === DateInputFieldType.Outline;
    };
    DateInputField.prototype.renderOutlineTextField = function (outlineTextFieldProps) {
        return (React.createElement(React.Fragment, null,
            React.createElement(SharedWidgets_1.OutlineTextFieldWidget, tslib_1.__assign({}, outlineTextFieldProps)),
            this.renderIcon()));
    };
    DateInputField.prototype.renderLineTextField = function (lineTextFieldProps) {
        return (React.createElement(React.Fragment, null,
            React.createElement(SharedWidgets_1.LineTextFieldWidget, tslib_1.__assign({}, lineTextFieldProps)),
            this.renderIcon()));
    };
    DateInputField.prototype.renderTextField = function () {
        var dateParsingErrorText = Localize_1.Messages.enterValidDate();
        var parsedDate = Date_1.getParsedDate(this.state.inputText, this.props.terminus);
        var errorText = parsedDate ? this.props.errorText : dateParsingErrorText;
        var hasError = !(parsedDate && !this.props.errorText);
        var numCols = 7;
        var containerStyle = tslib_1.__assign({}, this.props.style, { 
            // maxWidth is the width of the picker, because input width cannot be wider than the picker.
            // cell width (30px) * colNum + Spacing.DefaultSpace * 2 + Sizing.BorderWidth * 2
            maxWidth: 30 * numCols + TabStyles_1.TabStyles.Spacing.DefaultSpace * 2 + TabStyles_1.TabStyles.Sizing.BorderWidth * 2, position: 'relative' });
        var inputWithPopupStyle = {
            // leaving space for dropdown button
            paddingRight: 24,
        };
        var textFieldProps = {
            containerStyle: containerStyle,
            disabled: this.props.disabled,
            handleChange: this.handleChange,
            handleEnter: this.handleInputEnter,
            handleEscape: this.handleEscape,
            inputRef: this.handleInputRef,
            inputStyle: this.props.hasDatePicker ? inputWithPopupStyle : null,
            testId: this.props.testId + "-text-field",
            text: this.state.inputText,
        };
        var outlineTextFieldProps = tslib_1.__assign({}, textFieldProps, { displayErrorTextSection: true, errorText: errorText,
            hasError: hasError });
        var lineTextFieldProps = tslib_1.__assign({}, textFieldProps, { errorText: errorText });
        var ariaAttributes = this.props.hasDatePicker ? {
            'aria-expanded': !!this.state.isDatePickerOpen,
            'aria-haspopup': 'dialog',
            'aria-owns': (this.state.isDatePickerOpen ? this.datePickerId : undefined),
            role: 'combobox',
        } : undefined;
        return (React.createElement("div", tslib_1.__assign({ onBlur: this.handleBlur, onKeyDown: this.handleInputKeyDown, style: containerStyle }, ariaAttributes), this.isOutlineTextField() ? this.renderOutlineTextField(outlineTextFieldProps) : this.renderLineTextField(lineTextFieldProps)));
    };
    DateInputField.prototype.renderIcon = function () {
        if (!this.props.hasDatePicker) {
            return null;
        }
        var baseStyle = {
            borderRadius: 0,
            display: 'inline-flex',
            height: Sizing.RowHeight - 2 * Sizing.BorderWidth,
            minWidth: 0,
            position: 'absolute',
            right: 0,
            top: Sizing.BorderWidth,
        };
        var outlineStyle = tslib_1.__assign({}, baseStyle, { borderLeft: "1px solid " + Colors.L3, right: Sizing.BorderWidth });
        var buttonProps = {
            buttonType: SharedWidgets_2.ButtonType.IconOutline,
            disableTabAccessibility: true,
            disabled: this.props.disabled,
            getContent: function (state) { return React.createElement(DomWidgets_1.Img, { draggable: false, src: Icons_1.encodeSvg(Icons_1.DropdownArrowIcon.icon(state)) }); },
            handleClick: this.handleButtonClick,
            style: this.isOutlineTextField() ? outlineStyle : baseStyle,
            testId: this.props.testId,
        };
        return (React.createElement(SharedWidgets_2.ButtonWidget, tslib_1.__assign({}, buttonProps, { ref: this.handleDropdownButtonRef })));
    };
    DateInputField.prototype.renderOverlay = function () {
        var datePicker = this.state.isDatePickerOpen && this.props.hasDatePicker && this.renderDatePicker();
        if (!datePicker || !this.inputElement) {
            return null;
        }
        var style = {
            boxShadow: Shadow.Standard,
            lineHeight: 'normal',
            outline: 'none',
        };
        var datePickerAriaAttr = {
            id: this.datePickerId,
            role: 'dialog'
        };
        return (React.createElement(Overlay_1.Overlay, { allowAutoPosition: true, anchorEl: this.inputElement, anchorOrigin: { vertical: Overlay_1.VerticalOriginOption.bottom, horizontal: Overlay_1.HorizontalOriginOption.left }, stackingRootId: this.props.stackingRootId, portalEventTrapOverrides: {
                onKeyUp: this.handleOverlayKeyUp
            }, zIndex: this.props.zIndex },
            React.createElement("div", tslib_1.__assign({ onBlur: this.handlePickerBlur, ref: this.handleOverlayRef, style: style, tabIndex: -1 }, datePickerAriaAttr), datePicker)));
    };
    DateInputField.prototype.render = function () {
        return (React.createElement("div", { "data-tb-test-id": this.props.testId },
            this.renderTextField(),
            this.renderOverlay()));
    };
    DateInputField.defaultProps = {
        displayFormat: DateFormat.ShortDateWithFullYear,
        hasDatePicker: true,
        selectedDate: new Date(),
        showDatePickerWeekNumbers: false,
    };
    return DateInputField;
}(React.Component));
exports.DateInputField = DateInputField;
//# sourceMappingURL=DateInputField.js.map